var render, staticRenderFns
import script from "./ResultV1.vue?vue&type=script&lang=js&"
export * from "./ResultV1.vue?vue&type=script&lang=js&"
import style0 from "./ResultV1.vue?vue&type=style&index=0&id=0392c85d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0392c85d",
  null
  
)

export default component.exports